import React from 'react';
import PropTypes from 'prop-types';
import {
        ComposedChart, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip
    } from 'recharts';
import './LineAreaGraph.scss';

const LineAreaGraph = ({ title, width, data, tooltip }) => {

    return (
        <div className="line-area-graph">
            <ComposedChart
                width={width}
                height={175}
                data={data}
                margin={{
                    top: 20, right: -15, bottom: 20, left: -15,
                }}
                >
                <CartesianGrid stroke="#f5f5f5" />
                <XAxis dataKey="name" stroke="#ccc"/>
                <YAxis stroke="#ccc"/>
                <Tooltip content={tooltip} cursor={false}/>
                <Area type="monotone" dataKey="projected" fill="#ccc" stroke="#A5A5A5" />
                <Line type="monotone" dataKey="historical" stroke="#334D62" />
            </ComposedChart>
            <div className="title">{title}</div>
        </div>
    );

};

LineAreaGraph.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
      ]).isRequired,
    width: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    tooltip: PropTypes.element
};

export default LineAreaGraph;
